import { State, Reducer as ProjectsReducer } from './projects.reducer';

export { State };

export const projectsFeatureKey = 'projects';

export const reducers = ProjectsReducer;
